export default {
  title: 'page.index.mocks.title',
  ogTitle: 'page.index.mocks.og_title',
  description: 'page.index.mocks.description',
  ogDescription: 'page.index.mocks.og_description',
  ogImage: '/images/opengraph/main_1200x630.jpg'
}
